import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/incomeReport'
import { getIncomeReport as getIncome, postIncomeReport as postIncome } from 'services'

const {
  INCOME_REPORT_REQUEST,
  INCOME_REPORT_SUCCESS,
  INCOME_REPORT_ERROR,
  INCOME_REPORT_REQUEST_EMAIL,
  INCOME_REPORT_REQUEST_EMAIL_SUCCESS
} = ACTION_TYPES

export function *getIncomeReport(payload) {
  try {
    const response = yield call(getIncome, payload)
    yield put({ type: INCOME_REPORT_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: INCOME_REPORT_ERROR, payload: err })
  }
}

export function *postIncomeReport(payload) {
  try {
    const response = yield call(postIncome, payload)
    yield put({ type: INCOME_REPORT_REQUEST_EMAIL_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: INCOME_REPORT_ERROR, payload: err })
  }
}

export function *watchPostIncomeReport() {
  yield takeLatest(INCOME_REPORT_REQUEST_EMAIL, postIncomeReport)
}

export function *watchIncomeReport() {
  yield takeLatest(INCOME_REPORT_REQUEST, getIncomeReport)
}

export default {
  watchPostIncomeReport,
  watchIncomeReport
}
